export default __webpack_public_path__ + "3b1f494b8c60cca78e47b51581a59d49.svg";